module.exports = __webpack_public_path__ + "img/thumbnail.1eca33a2.jpg";